export default __webpack_public_path__ + "static/B0022-176009c3dc81ee9da7e56d276c311ccb.png";